module.exports = __webpack_public_path__ + "img/blog-1.3dd48b61.webp";